var TypeFilter = React.createClass({
  propTypes: {
    selectedTypes: React.PropTypes.arrayOf(React.PropTypes.string),
    onTypesChanged: React.PropTypes.func
  },
  getDefaultProps() {
    return {
      defaultTypes:[{code:"raserviceRequest",description:"Service Request"},{code:"rarightPath",description:"Right Path"},{code:"ravideo",description:"Video"}],
      selectedTypes: []
    }
  },
 typeClicked(code) {
    let checkedTypes = this.props.selectedTypes;
    let isSelected = this.isTypeSelected(code);
    if (!isSelected) {
      checkedTypes.push(code);
    } else {
      checkedTypes = checkedTypes.filter(val => val != code);
    }

    if (this.props.onTypesChanged) {
      this.props.onTypesChanged(checkedTypes);
    }
  },
  isTypeSelected(code) {
    return this.props.selectedTypes.indexOf(code) != -1;
  },
  getItem(type) {
    return (
      <li className="filter__item" key={type.code}>
        <RACheck label={Labels.getLabel(type.description)}
          value={type.code}
          isChecked={this.isTypeSelected(type.code)}
          onClick={this.typeClicked} />
      </li>
    )
  },
  render() {
    if (this.props.defaultTypes.length == 0) {
      return <span />
    }

    return (
      <BrowseFilter title={Labels.getLabel("Type")} filterType="filter-type__type" ariaLabel="Solution type filter" isOpen={this.props.isOpen}>
        <ul className="filter__list">
        {this.props.defaultTypes.map(this.getItem)}

        </ul>
      </BrowseFilter>
    )
  }
});